export const WHATSAPP_NUMBER = "393509946798";
export const WHATSAPP_DISPLAY = "+39 350 994 6798";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    message || "Bonjour King of Sourcing, je souhaite un renseignement sur le sourcing en Chine / Corée."
  )}`;

export const CONTACT = {
  email: "contact@kingofsourcing.com",
  phone: WHATSAPP_DISPLAY,
  location: "Italie, Europe",
  legalName: "BILLYJUNIORLTDSHOP LTD",
  registeredAddress: "71-75 Shelton Street, Covent Garden, Londres WC2H 9JQ",
  landline: "+44 20 3897 2256",
  socials: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    tiktok: "https://www.tiktok.com/@kingofsourcing",
  },
};

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/5726ab62-6fde-4cc4-8885-f9b6723ac004/images/adf76a4835da817749dcff701ac4aa95403dfe7d5bc88654901cd332d15a9315.png";

export const IMAGES = {
  cargo: "https://images.unsplash.com/photo-1782398138808-694776d26c4c",
  delivery: "https://images.unsplash.com/photo-1656543802898-41c8c46683a7",
  port: "https://images.unsplash.com/photo-1769144256181-698b8f807066",
  meeting: "https://static.prod-images.emergentagent.com/jobs/5726ab62-6fde-4cc4-8885-f9b6723ac004/images/5202235affa8d5bde96d9d55e95a9d4113b39525c135a3f76b24ef59d635126b.png",
};

export const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1571086291540-b137111fa1c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    caption: "Transport aérien — livraison express dans le monde entier",
  },
  {
    url: "https://images.unsplash.com/photo-1605745341112-85968b19335b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    caption: "Transport maritime — fret conteneurisé partout dans le monde",
  },
];
